import React, { useContext, useEffect } from "react";
import { useState } from "react";
import {
    Box,
    Checkbox,
    FormControlLabel,
    Snackbar,
    Stack,
    TextField,
    Typography,
} from "@mui/material";
import { Paper, TableBody } from "@mui/material";
import { TableCell, TableContainer, TableHead, TableRow } from "@mui/material";
import {
    StyledTableHead,
    StyledTableCell,
} from "../../../Styles/tabelCellStyled/customTableCell";
import BasicPopover from "../../../Components/Popover";
import {
    CustomSelect,
    CustomTextField,
} from "../../../Styles/theme/customThemeprovider";
import { BarraDeFerramentas } from "../../../Components/barra-de-ferramentas/BarraDeFerramentas";
import { ButtonCadernos } from "../../../Components/barra-de-ferramentas/ButtonCadernos";
import { TabelaComposicaoHead } from "./tabela_composicao_head";
import ConfirmDialog from "../../../Components/CustomDialog/customdialog";
import { IComposicaoQ1, IComposicaoQ2 } from "../../../Interfaces/anexos/anexo1/composicao_adubacao_azoto_nutrientes1_4_7";
import { Alert } from "../../../Components/Alert/Alert";
import { especie } from "../../../informacao_estatica";
import { ICabecalho } from "../../../Interfaces/anexos/anexo1/analise_e_foliar1_1_3";
import { del, get, post } from "../../../Services/tokenConfig";
import { func_print } from "../../../Func_genericas/func_print";
import { AuthContext } from "../../../AuthContext/AuthContext";
import { format_strings_to_numbers } from "../../../Componentes_modulo/formulas_genericas/formulas_genericas";
import { mensagem_tem_a_certeza_de_apagar_alteracoes } from "../../../Func_genericas/valores_estaticos";
import { useLocation } from "react-router-dom";


interface ComposicaoQ1Form_prop {
    obj_anexo_cabecalho_selecionado: ICabecalho | undefined;
}

export const ComposicaoQ1Form: React.FC<ComposicaoQ1Form_prop> = ({ obj_anexo_cabecalho_selecionado }) => {
    const auth = useContext(AuthContext);

    const location = useLocation();
    const is_historico = location.state?.is_historico ?? false;

    const [open_dialog_tem_a_certeza_que_quer_eliminar, set_open_dialog_tem_a_certeza_que_quer_eliminar] = useState(false);
    const [open_dialog_tem_a_certeza_que_quer_eliminar_q2, set_open_dialog_tem_a_certeza_que_quer_eliminar_q2] = useState(false);

    const [flag_editar, set_flag_editar] = useState(true);
    const [createTable, setCreateTable] = useState(false);
    const [createTableEstrume, setCreateTableEstrume] = useState(false);
    const [createTableChorume, setCreateTableChorume] = useState(false);

    const [message, setMessage] = useState("");
    const [obj_anexo_lista, set_obj_anexo_lista] = useState<IComposicaoQ1[]>([]);
    const [obj_anexo_lista_q2, set_obj_anexo_lista_q2] = useState<IComposicaoQ2[]>([]);
    const [openSnackSuccess, setOpenSnackSuccess] = useState(false);
    const [openSnackError, setOpenSnackError] = useState(false);
    const [obj_anexo, set_obj_anexo] = useState<IComposicaoQ1>();
    const [obj_anexo_to_edit, set_obj_anexo_to_edit] = useState<IComposicaoQ1>();

    const [obj_anexo_q2, set_obj_anexo_q2] = useState<IComposicaoQ2>();
    const [error_estrume_camp2, set_error_estrume_camp2] = useState(false);
    const [error_estrume_camp3, set_error_estrume_camp3] = useState(false);
    const [error_estrume_camp4, set_error_estrume_camp4] = useState(false);
    const [error_chorume_camp2, set_error_chorume_camp2] = useState(false);
    const [error_chorume_camp3, set_error_chorume_camp3] = useState(false);
    const [error_chorume_camp4, set_error_chorume_camp4] = useState(false);

    const [existe_cabecalho, set_existe_cabecalho] = useState(false)

    const [isLoading, setIsLoading] = useState(false);

    const [flag_editado, set_flag_editado] = React.useState(false);
    const [open_modal_tem_a_certeza_que_quer_apagar_alteracoes, set_open_modal_tem_a_certeza_que_quer_apagar_alteracoes] = React.useState(false);



    const handle_update_anexo = async () => {
        if (error_estrume_camp2 || error_estrume_camp3 || error_estrume_camp4 || error_chorume_camp2 || error_chorume_camp3 || error_chorume_camp4) {
            setMessage("Erro ao efetuar a sua operação!");
            setOpenSnackError(true);

        } else {
            try {
                setIsLoading(true);
                let res = await post(auth.token.cookie_token, "update_reg_anexo_um_quatro_um", { payload: obj_anexo });

                if (res.status === 200) {
                    let lista_aux: any = obj_anexo_lista.map((el) => {
                        if (el.id_anexo_um_quatro_um !== obj_anexo?.id_anexo_um_quatro_um) {
                            return el
                        } else {
                            return res.data.result
                        }
                    })
                    set_obj_anexo_lista(lista_aux === undefined ? [] : lista_aux)
                    set_obj_anexo(undefined);
                    set_flag_editar(false)
                    set_flag_editado(false)
                    setMessage("Gravado com sucesso!");
                    setOpenSnackSuccess(true);
                } else {
                    setMessage("Erro ao gravar!");

                    setOpenSnackError(true);
                }

                setIsLoading(false);
            } catch (error) {
                func_print("handle_update_anexo", error, true);
                setMessage("Erro ao gravar!");

                setOpenSnackError(true);
                setIsLoading(false);
            }
        }
    };
    const handle_update_anexo_q2 = async () => {
        try {
            setIsLoading(true);

            let res = await post(auth.token.cookie_token, "update_reg_anexo_um_quatro_dois", { payload: obj_anexo_q2 });

            if (res.status === 200) {
                let lista_aux: any = obj_anexo_lista_q2.map((el) => {
                    if (el.id_anexo_um_quatro_um !== obj_anexo_q2?.id_anexo_um_quatro_um) {
                        return el
                    } else {
                        return res.data.result
                    }
                })
                set_flag_editado(false)

                set_obj_anexo_lista_q2(lista_aux === undefined ? [] : lista_aux)
                set_obj_anexo_q2(undefined);
                set_flag_editar(false)
                setMessage("Gravado com sucesso!");
                setOpenSnackSuccess(true);
            } else {
                setMessage("Erro ao gravar!");

                setOpenSnackError(true);
            }

            setIsLoading(false);
        } catch (error) {
            func_print("handle_update_anexo", error, true);
            setMessage("Erro ao gravar!");

            setOpenSnackError(true);
            setIsLoading(false);
        }
    };

    const onEditTableChangeTable = (event: any) => {
        const { name, value, type, checked } = event.target;
        set_flag_editado(true)

        if (type === "checkbox") {
            set_obj_anexo((prev: any) => {
                return {
                    ...prev,
                    [name]: checked,
                };
            });
        } else {

            set_obj_anexo_q2((old: any) => ({
                ...old,
                [name]: value,
            }));
        }
    }

    const onInputChange = (event: any) => {
        const { name, value, type, checked } = event.target;
        set_flag_editado(true)

        if (type === "checkbox") {
            set_obj_anexo_q2((prev: any) => {
                return {
                    ...prev,
                    [name]: checked,
                };
            });
        } else {
            if (name === 'estrume_camp2') {
                if (/[a-zA-Z]/.test(value)) {
                    set_error_estrume_camp2(true)
                } else {
                    set_error_estrume_camp2(false)
                }
                set_obj_anexo_to_edit((old: any) => ({
                    ...old,
                    [name]: format_strings_to_numbers(value, false),
                }));
            } else if (name === 'estrume_camp3') {
                if (/[a-zA-Z]/.test(value)) {
                    set_error_estrume_camp3(true)
                } else {
                    set_error_estrume_camp3(false)
                }
                set_obj_anexo_to_edit((old: any) => ({
                    ...old,
                    [name]: format_strings_to_numbers(value, false),
                }));
            } else if (name === 'estrume_camp4') {
                if (/[a-zA-Z]/.test(value)) {
                    set_error_estrume_camp4(true)
                } else {
                    set_error_estrume_camp4(false)
                }
                set_obj_anexo_to_edit((old: any) => ({
                    ...old,
                    [name]: format_strings_to_numbers(value, false),
                }));
            } else if (name === 'chorume_camp2') {
                if (/[a-zA-Z]/.test(value)) {
                    set_error_chorume_camp2(true)
                } else {
                    set_error_chorume_camp2(false)
                }
                set_obj_anexo_to_edit((old: any) => ({
                    ...old,
                    [name]: format_strings_to_numbers(value, false),
                }));
            } else if (name === 'chorume_camp3') {
                if (/[a-zA-Z]/.test(value)) {
                    set_error_chorume_camp3(true)
                } else {
                    set_error_chorume_camp3(false)
                }
                set_obj_anexo_to_edit((old: any) => ({
                    ...old,
                    [name]: format_strings_to_numbers(value, false),
                }));
            } else if (name === 'chorume_camp4') {
                if (/[a-zA-Z]/.test(value)) {
                    set_error_chorume_camp4(true)
                } else {
                    set_error_chorume_camp4(false)
                }
                set_obj_anexo_to_edit((old: any) => ({
                    ...old,
                    [name]: format_strings_to_numbers(value, false),
                }));
            } else {
                set_obj_anexo_to_edit((old: any) => ({
                    ...old,
                    [name]: value,
                }));
            }

        }
    };

    const onEditTableChange = (event: any) => {
        const { name, value, type, checked } = event.target;
        let aux_obj_anexo: any = obj_anexo === undefined ? {} : obj_anexo
        set_flag_editado(true)

        if (type === "checkbox") {
            aux_obj_anexo[name] = aux_obj_anexo[name] === undefined ? true : !aux_obj_anexo[name]
            set_obj_anexo(aux_obj_anexo);
        } else {
            if (name === 'estrume_camp2') {
                if (/[a-zA-Z]/.test(value)) {
                    set_error_estrume_camp2(true)
                } else {
                    set_error_estrume_camp2(false)
                }
                set_obj_anexo((old: any) => ({
                    ...old,
                    [name]: format_strings_to_numbers(value, false),
                }));
            } else if (name === 'estrume_camp3') {
                if (/[a-zA-Z]/.test(value)) {
                    set_error_estrume_camp3(true)
                } else {
                    set_error_estrume_camp3(false)
                }
                set_obj_anexo((old: any) => ({
                    ...old,
                    [name]: format_strings_to_numbers(value, false),
                }));
            } else if (name === 'estrume_camp4') {
                if (/[a-zA-Z]/.test(value)) {
                    set_error_estrume_camp4(true)
                } else {
                    set_error_estrume_camp4(false)
                }
                set_obj_anexo((old: any) => ({
                    ...old,
                    [name]: format_strings_to_numbers(value, false),
                }));
            } else if (name === 'chorume_camp2') {
                if (/[a-zA-Z]/.test(value)) {
                    set_error_chorume_camp2(true)
                } else {
                    set_error_chorume_camp2(false)
                }
                set_obj_anexo((old: any) => ({
                    ...old,
                    [name]: format_strings_to_numbers(value, false),
                }));
            } else if (name === 'chorume_camp3') {
                if (/[a-zA-Z]/.test(value)) {
                    set_error_chorume_camp3(true)
                } else {
                    set_error_chorume_camp3(false)
                }
                set_obj_anexo((old: any) => ({
                    ...old,
                    [name]: format_strings_to_numbers(value, false),
                }));
            } else if (name === 'chorume_camp4') {
                if (/[a-zA-Z]/.test(value)) {
                    set_error_chorume_camp4(true)
                } else {
                    set_error_chorume_camp4(false)
                }
                set_obj_anexo((old: any) => ({
                    ...old,
                    [name]: format_strings_to_numbers(value, false),
                }));
            } else {
                set_obj_anexo((old: any) => ({
                    ...old,
                    [name]: value,
                }));
            }
        }
    };

    const filteredRowsEstrume = obj_anexo_lista.filter(
        (tab) =>
            tab &&
            (tab.estrume_camp1 ||
                tab.estrume_camp2 ||
                tab.estrume_camp3 ||
                tab.estrume_camp4)
    );

    const filteredRowsChorume = obj_anexo_lista.filter(
        (tab) =>
            tab &&
            (tab.chorume_camp1 ||
                tab.chorume_camp2 ||
                tab.chorume_camp3 ||
                tab.chorume_camp4)
    );

    const handleCloseSnack = () => {
        setOpenSnackSuccess(false);
        setOpenSnackError(false);
    };

    const handle_criar_anexo = async () => {
        if (error_estrume_camp2 || error_estrume_camp3 || error_estrume_camp4 || error_chorume_camp2 || error_chorume_camp3 || error_chorume_camp4) {
            setMessage("Erro ao efetuar a sua operação!");
            setOpenSnackError(true);

        } else {

            try {
                setIsLoading(true);

                let data = await post(auth.token.cookie_token, "new_reg_anexo_um_quatro_um", {
                    payload: {

                        id_anexo_um_quatro_um: 0,
                        estrume_camp1: obj_anexo_to_edit?.estrume_camp1 === undefined ? '' : obj_anexo_to_edit?.estrume_camp1,
                        estrume_camp2: obj_anexo_to_edit?.estrume_camp2 === undefined ? '' : obj_anexo_to_edit?.estrume_camp2,
                        estrume_camp3: obj_anexo_to_edit?.estrume_camp3 === undefined ? '' : obj_anexo_to_edit?.estrume_camp3,
                        estrume_camp4: obj_anexo_to_edit?.estrume_camp4 === undefined ? '' : obj_anexo_to_edit?.estrume_camp4,
                        chorume_camp1: obj_anexo_to_edit?.chorume_camp1 === undefined ? '' : obj_anexo_to_edit?.chorume_camp1,
                        chorume_camp2: obj_anexo_to_edit?.chorume_camp2 === undefined ? '' : obj_anexo_to_edit?.chorume_camp2,
                        chorume_camp3: obj_anexo_to_edit?.chorume_camp3 === undefined ? '' : obj_anexo_to_edit?.chorume_camp3,
                        chorume_camp4: obj_anexo_to_edit?.chorume_camp4 === undefined ? '' : obj_anexo_to_edit?.chorume_camp4,
                        id_anexo_um_cabecalho: obj_anexo_cabecalho_selecionado?.id_anexo_um_cabecalho,
                        last_update: new Date().toISOString(),
                        create_date: new Date().toISOString(),
                        uuid: ""
                    }
                })
                if (data.status === 200) {
                    set_flag_editado(false)

                    setMessage("Operação efetuada com sucesso!");
                    setOpenSnackSuccess(true);
                    set_obj_anexo_lista((old) => [...old, data.data.result])
                    set_obj_anexo_to_edit(undefined)
                    setCreateTableEstrume(false)
                    setCreateTableChorume(false)
                    set_flag_editar(false)
                } else {
                    setMessage("Erro ao efetuar a sua operação!");
                    setOpenSnackError(true);
                }
                setIsLoading(false);

            } catch (error) {
                func_print('handle_criar_anexo', error, true)
                setIsLoading(false);

                setMessage("Erro ao efetuar a sua operação!");
                setOpenSnackError(true);
            }
        }
    }

    const handle_criar_anexo_q2 = async () => {
        try {
            setIsLoading(true);

            let data = await post(auth.token.cookie_token, "new_reg_anexo_um_quatro_dois", {
                payload: {

                    id_anexo_um_quatro_um: 0,
                    digerido_camp1: obj_anexo_q2?.digerido_camp1 === undefined ? '' : obj_anexo_q2?.digerido_camp1,
                    digerido_camp2: obj_anexo_q2?.digerido_camp2 === undefined ? '' : obj_anexo_q2?.digerido_camp2,
                    digerido_camp3: obj_anexo_q2?.digerido_camp3 === undefined ? '' : obj_anexo_q2?.digerido_camp3,
                    digerido_camp4: obj_anexo_q2?.digerido_camp4 === undefined ? '' : obj_anexo_q2?.digerido_camp4,
                    sedimentos_camp1: obj_anexo_q2?.sedimentos_camp1 === undefined ? '' : obj_anexo_q2?.sedimentos_camp1,
                    sedimentos_camp2: obj_anexo_q2?.sedimentos_camp2 === undefined ? '' : obj_anexo_q2?.sedimentos_camp2,
                    sedimentos_camp3: obj_anexo_q2?.sedimentos_camp3 === undefined ? '' : obj_anexo_q2?.sedimentos_camp3,
                    sedimentos_camp4: obj_anexo_q2?.sedimentos_camp4 === undefined ? '' : obj_anexo_q2?.sedimentos_camp4,
                    mistura_camp1: obj_anexo_q2?.mistura_camp1 === undefined ? '' : obj_anexo_q2?.mistura_camp1,
                    mistura_camp2: obj_anexo_q2?.mistura_camp2 === undefined ? '' : obj_anexo_q2?.mistura_camp2,
                    mistura_camp3: obj_anexo_q2?.mistura_camp3 === undefined ? '' : obj_anexo_q2?.mistura_camp3,
                    mistura_camp4: obj_anexo_q2?.mistura_camp4 === undefined ? '' : obj_anexo_q2?.mistura_camp4,
                    composto_camp1: obj_anexo_q2?.composto_camp1 === undefined ? '' : obj_anexo_q2?.composto_camp1,
                    composto_camp2: obj_anexo_q2?.composto_camp2 === undefined ? '' : obj_anexo_q2?.composto_camp2,
                    composto_camp3: obj_anexo_q2?.composto_camp3 === undefined ? '' : obj_anexo_q2?.composto_camp3,
                    composto_camp4: obj_anexo_q2?.composto_camp4 === undefined ? '' : obj_anexo_q2?.composto_camp4,
                    opcao_um_camp1: obj_anexo_q2?.opcao_um_camp1 === undefined ? '' : obj_anexo_q2?.opcao_um_camp1,
                    opcao_um_camp2: obj_anexo_q2?.opcao_um_camp2 === undefined ? '' : obj_anexo_q2?.opcao_um_camp2,
                    opcao_um_camp3: obj_anexo_q2?.opcao_um_camp3 === undefined ? '' : obj_anexo_q2?.opcao_um_camp3,
                    opcao_um_camp4: obj_anexo_q2?.opcao_um_camp4 === undefined ? '' : obj_anexo_q2?.opcao_um_camp4,
                    opcao_dois_camp1: obj_anexo_q2?.opcao_dois_camp1 === undefined ? '' : obj_anexo_q2?.opcao_dois_camp1,
                    opcao_dois_camp2: obj_anexo_q2?.opcao_dois_camp2 === undefined ? '' : obj_anexo_q2?.opcao_dois_camp2,
                    opcao_dois_camp3: obj_anexo_q2?.opcao_dois_camp3 === undefined ? '' : obj_anexo_q2?.opcao_dois_camp3,
                    opcao_dois_camp4: obj_anexo_q2?.opcao_dois_camp4 === undefined ? '' : obj_anexo_q2?.opcao_dois_camp4,
                    origem_tabela: obj_anexo_q2?.origem_tabela === undefined ? false : obj_anexo_q2?.origem_tabela,
                    origem_analise: obj_anexo_q2?.origem_analise === undefined ? false : obj_anexo_q2?.origem_analise,
                    tabela: obj_anexo_q2?.tabela === undefined ? '' : obj_anexo_q2?.tabela,
                    analise: obj_anexo_q2?.analise === undefined ? null : obj_anexo_q2?.analise,
                    id_anexo_um_cabecalho: obj_anexo_cabecalho_selecionado?.id_anexo_um_cabecalho,
                    last_update: new Date().toISOString(),
                    create_date: new Date().toISOString(),
                    uuid: ""
                }
            })
            if (data.status === 200) {
                setMessage("Operação efetuada com sucesso!");
                setOpenSnackSuccess(true);
                set_obj_anexo_lista_q2((old) => [...old, data.data.result])
                set_obj_anexo_q2(undefined)
                setCreateTable(false)
                set_flag_editado(false)

            } else {
                setMessage("Erro ao efetuar a sua operação!");
                setOpenSnackError(true);
            }
            setIsLoading(false);

        } catch (error) {
            func_print('handle_criar_anexo', error, true)
            setIsLoading(false);

            setMessage("Erro ao efetuar a sua operação!");
            setOpenSnackError(true);
        }
    }
    const get_info = async () => {
        try {
            let res = await get(auth.token.cookie_token,
                `/get_reg_anexo_um_quatro_um_cabecalho/${obj_anexo_cabecalho_selecionado?.id_anexo_um_cabecalho}`
            );
            let res_q2 = await get(auth.token.cookie_token,
                `/get_reg_anexo_um_quatro_dois_cabecalho/${obj_anexo_cabecalho_selecionado?.id_anexo_um_cabecalho}`
            );
            if (res.status === 200) {
                if (res.data.result.length !== 0) {
                    set_obj_anexo_lista(res.data.result);
                } else {
                    set_flag_editar(false)
                }
            } else {
                setMessage("Erro a carregar informação!");
                setOpenSnackError(true);
            }
            if (res_q2.status === 200) {
                if (res_q2.data.result.length !== 0) {
                    set_obj_anexo_lista_q2(res_q2.data.result);
                } else {
                    setCreateTable(true)
                }
            } else {
                setMessage("Erro a carregar informação!");
                setOpenSnackError(true);
            }
            setIsLoading(false);
        } catch (error) {
            func_print("get_info", error, true);
            setMessage("Erro!");

            setOpenSnackError(true);
            setIsLoading(false);
        }
    };

    useEffect(() => {
        (async () => {
            if (obj_anexo_cabecalho_selecionado !== undefined) {

                await get_info();
                set_existe_cabecalho(true)
                set_flag_editar(false)
            } else {
                set_existe_cabecalho(false)
                set_obj_anexo_lista([])
                set_obj_anexo_lista_q2([])
                set_flag_editar(true)
            }
        })();
    }, [obj_anexo_cabecalho_selecionado]);

    const handle_delete_anexo = async () => {
        try {
            setIsLoading(true);

            let res = await del(auth.token.cookie_token,
                `delete__reg_anexo_um_quatro_um/${obj_anexo?.id_anexo_um_quatro_um}`
            );
            if (res.status === 200) {
                let lista_aux: any = obj_anexo_lista.filter((el) => {
                    if (el.id_anexo_um_quatro_um !== obj_anexo?.id_anexo_um_quatro_um) {
                        return el
                    }
                })
                set_obj_anexo_lista(lista_aux === undefined ? [] : lista_aux)
                set_obj_anexo(undefined)
                setMessage("Registo eliminado com sucesso!");
                set_open_dialog_tem_a_certeza_que_quer_eliminar(false);
                setOpenSnackSuccess(true);

            } else {
                setMessage("Erro ao eliminar o registo!");
                setOpenSnackError(true);
            }
            setIsLoading(false);
        } catch (error) {
            func_print("handle_delete_anexo", error, true);
            setIsLoading(false);
            setMessage("Erro ao eliminar o registo!");
            setOpenSnackError(true);
        }
    };
    const handle_delete_anexo_q2 = async () => {
        try {
            setIsLoading(true);

            let res = await del(auth.token.cookie_token,
                `delete__reg_anexo_um_quatro_dois/${obj_anexo_q2?.id_anexo_um_quatro_um}`
            );
            if (res.status === 200) {
                let lista_aux: any = obj_anexo_lista_q2.filter((el) => {
                    if (el.id_anexo_um_quatro_um !== obj_anexo_q2?.id_anexo_um_quatro_um) {
                        return el
                    }
                })
                set_obj_anexo_lista_q2(lista_aux === undefined ? [] : lista_aux)
                set_obj_anexo_q2(undefined)
                if (lista_aux === undefined || lista_aux.length === 0) {
                    setCreateTable(true)
                }
                setMessage("Registo eliminado com sucesso!");
                set_open_dialog_tem_a_certeza_que_quer_eliminar_q2(false);
                setOpenSnackSuccess(true);

            } else {
                setMessage("Erro ao eliminar o registo!");
                setOpenSnackError(true);
            }
            setIsLoading(false);
        } catch (error) {
            func_print("handle_delete_anexo", error, true);
            setIsLoading(false);
            setMessage("Erro ao eliminar o registo!");
            setOpenSnackError(true);
        }
    };
    const handleCloseDialog = () => {

        set_error_chorume_camp2(false)
        set_error_chorume_camp3(false)
        set_error_chorume_camp4(false)
        set_error_estrume_camp2(false)
        set_error_estrume_camp3(false)
        set_error_estrume_camp4(false)

        set_obj_anexo(undefined)
        set_obj_anexo_to_edit(undefined)
        set_flag_editar(false)
        setCreateTable(false)
        set_obj_anexo_q2(undefined)
        setCreateTableEstrume(false)
        setCreateTableChorume(false)


        set_flag_editado(false)
        set_open_modal_tem_a_certeza_que_quer_apagar_alteracoes(false)
        obj_anexo_lista_q2.length === 0 ? setCreateTable(true) : setCreateTable(false)

    };

    return (

        <TableContainer
            component={Paper}
            variant="outlined"
            sx={{
                height: "auto",
                width: "auto",
                margin: 2,
                padding: 2,
            }}
        >
            <Snackbar
                open={openSnackSuccess}
                autoHideDuration={2000}
                onClose={handleCloseSnack}
            >
                <Alert
                    onClose={handleCloseSnack}
                    severity="success"
                    sx={{ width: "100%" }}
                >
                    {message}
                </Alert>
            </Snackbar>
            <Snackbar
                open={openSnackError}
                autoHideDuration={2000}
                onClose={handleCloseSnack}
            >
                <Alert
                    onClose={handleCloseSnack}
                    severity="error"
                    sx={{ width: "100%" }}
                >
                    {message}
                </Alert>
            </Snackbar>
            <table style={{ width: "100%" }}>
                <TableHead>
                    <TabelaComposicaoHead />
                </TableHead>
                {
                    existe_cabecalho === true ?
                        <TableBody>
                            {createTableEstrume ? (
                                <TableRow>
                                    <StyledTableHead>Estrume</StyledTableHead>
                                    <StyledTableCell>
                                        <CustomSelect
                                            value={obj_anexo_to_edit?.estrume_camp1 === undefined ? '' : obj_anexo_to_edit?.estrume_camp1}
                                            name="estrume_camp1"
                                            onChange={onInputChange}
                                            options={especie}
                                            label=""
                                        />
                                    </StyledTableCell>
                                    <StyledTableCell>
                                        <CustomTextField
                                            name="estrume_camp2"
                                            value={obj_anexo_to_edit?.estrume_camp2 === undefined ? '' : obj_anexo_to_edit?.estrume_camp2.toString().replace('.', ',')}
                                            onChange={onInputChange}
                                            error={error_estrume_camp2}
                                            helperText={error_estrume_camp2 ? "Apenas números são aceites" : ""}
                                        />
                                    </StyledTableCell>
                                    <StyledTableCell>
                                        <CustomTextField
                                            name="estrume_camp3"
                                            value={obj_anexo_to_edit?.estrume_camp3 === undefined ? '' : obj_anexo_to_edit?.estrume_camp3.toString().replace('.', ',')}
                                            onChange={onInputChange}
                                            error={error_estrume_camp3}
                                            helperText={error_estrume_camp3 ? "Apenas números são aceites" : ""}
                                        />
                                    </StyledTableCell>
                                    <StyledTableCell>
                                        <CustomTextField
                                            name="estrume_camp4"
                                            value={obj_anexo_to_edit?.estrume_camp4 === undefined ? '' : obj_anexo_to_edit?.estrume_camp4.toString().replace('.', ',')}
                                            onChange={onInputChange}
                                            error={error_estrume_camp4}
                                            helperText={error_estrume_camp4 ? "Apenas números são aceites" : ""}
                                        />
                                    </StyledTableCell>
                                    <StyledTableCell>
                                        <ButtonCadernos
                                            mostrarBotaoCancelar
                                            aoClicarCancelar={() => {
                                                if (flag_editado) {
                                                    set_open_modal_tem_a_certeza_que_quer_apagar_alteracoes(true)

                                                } else {
                                                    set_obj_anexo_to_edit(undefined)
                                                    setCreateTableEstrume(false)
                                                    set_flag_editar(false)
                                                }
                                            }}
                                            mostrarBotaoGravar
                                            aoClicarGravar={() => { handle_criar_anexo() }}
                                        />
                                    </StyledTableCell>
                                </TableRow>
                            ) : (
                                <TableRow>
                                    <TableCell colSpan={7}>
                                        <Box
                                            sx={{
                                                display: "flex",
                                                justifyContent: "end",
                                                alignContent: "end",
                                            }}
                                        >
                                            {is_historico === true ? <></> :

                                                <BarraDeFerramentas
                                                    mostrarBotaoNovo
                                                    textoBotaoNovo="Adicionar linha Estrume"
                                                    aoClicarNovo={() => {
                                                        setCreateTableEstrume(true)
                                                        set_obj_anexo(undefined)
                                                    }}
                                                />}
                                        </Box>
                                    </TableCell>
                                </TableRow>
                            )}

                            {filteredRowsEstrume.length === 0 ? <></> :
                                filteredRowsEstrume.map((tab, key) => {
                                    if (tab.id_anexo_um_quatro_um === obj_anexo?.id_anexo_um_quatro_um) {

                                        return (
                                            <TableRow key={key}>
                                                {key === 0 && (
                                                    <StyledTableHead rowSpan={filteredRowsEstrume.length}>
                                                        Estrume
                                                    </StyledTableHead>
                                                )}
                                                <StyledTableCell>
                                                    <CustomSelect
                                                        value={obj_anexo?.estrume_camp1 === undefined ? '' : obj_anexo?.estrume_camp1}
                                                        name="estrume_camp1"
                                                        onChange={onEditTableChange}
                                                        options={especie}
                                                        label="Espécie Pecuária"
                                                    />
                                                </StyledTableCell>
                                                <StyledTableCell>
                                                    <CustomTextField
                                                        name="estrume_camp2"
                                                        value={obj_anexo?.estrume_camp2 === undefined ? '' : obj_anexo?.estrume_camp2.toString().replace('.', ',')}
                                                        onChange={onEditTableChange}
                                                        error={error_estrume_camp2}
                                                        helperText={error_estrume_camp2 ? "Apenas números são aceites" : ""}
                                                    />
                                                </StyledTableCell>
                                                <StyledTableCell>
                                                    <CustomTextField
                                                        name="estrume_camp3"
                                                        value={obj_anexo?.estrume_camp3 === undefined ? '' : obj_anexo?.estrume_camp3.toString().replace('.', ',')}
                                                        onChange={onEditTableChange}
                                                        error={error_estrume_camp3}
                                                        helperText={error_estrume_camp3 ? "Apenas números são aceites" : ""}
                                                    />
                                                </StyledTableCell>
                                                <StyledTableCell>
                                                    <CustomTextField
                                                        name="estrume_camp4"
                                                        value={obj_anexo?.estrume_camp4 === undefined ? '' : obj_anexo?.estrume_camp4.toString().replace('.', ',')}
                                                        onChange={onEditTableChange}
                                                        error={error_estrume_camp4}
                                                        helperText={error_estrume_camp4 ? "Apenas números são aceites" : ""}
                                                    />
                                                </StyledTableCell>
                                                <StyledTableCell>
                                                    <ButtonCadernos
                                                        mostrarBotaoCancelar
                                                        aoClicarCancelar={() => {
                                                            if (flag_editado) {
                                                                set_open_modal_tem_a_certeza_que_quer_apagar_alteracoes(true)

                                                            } else {
                                                                set_obj_anexo(undefined)
                                                                set_obj_anexo_to_edit(undefined)
                                                                setCreateTableEstrume(false)
                                                                set_flag_editar(false)
                                                                obj_anexo_lista_q2.length === 0 ? setCreateTable(true) : setCreateTable(false)

                                                            }
                                                        }}
                                                        mostrarBotaoGravar
                                                        aoClicarGravar={() => {
                                                            handle_update_anexo()
                                                        }}
                                                    />
                                                </StyledTableCell>
                                            </TableRow>

                                        );
                                    } else {

                                        return (
                                            <>
                                                <TableRow>

                                                    {key === 0 && (
                                                        <StyledTableHead rowSpan={filteredRowsEstrume.length}>
                                                            Estrume
                                                        </StyledTableHead>
                                                    )}
                                                    <StyledTableCell>{tab.estrume_camp1}</StyledTableCell>
                                                    <StyledTableCell>{tab.estrume_camp2}</StyledTableCell>
                                                    <StyledTableCell>{tab.estrume_camp3}</StyledTableCell>
                                                    <StyledTableCell>{tab.estrume_camp4}</StyledTableCell>
                                                    <StyledTableCell>
                                                        <ButtonCadernos
                                                            mostrarBotaoEditar
                                                            aoClicarEditar={() => {
                                                                setCreateTable(false)
                                                                setCreateTableChorume(false)
                                                                setCreateTableEstrume(false)
                                                                set_obj_anexo(tab)
                                                                set_flag_editar(true)
                                                            }}
                                                            mostrarBotaoApagar
                                                            aoClicarApagar={() => {
                                                                set_obj_anexo(tab)
                                                                set_flag_editar(false)
                                                                set_open_dialog_tem_a_certeza_que_quer_eliminar(true)
                                                            }}
                                                        />
                                                    </StyledTableCell>
                                                </TableRow>
                                            </>
                                        )
                                    }

                                })}
                            {createTableChorume ? (
                                <TableRow>
                                    <StyledTableHead>Chorume</StyledTableHead>
                                    <StyledTableCell>
                                        <CustomSelect
                                            value={obj_anexo_to_edit?.chorume_camp1 === undefined ? '' : obj_anexo_to_edit?.chorume_camp1}
                                            name="chorume_camp1"
                                            onChange={onInputChange}
                                            options={especie}
                                            label="Espécie Pecuária"
                                        />
                                    </StyledTableCell>
                                    <StyledTableCell>
                                        <CustomTextField
                                            name="chorume_camp2"
                                            value={obj_anexo_to_edit?.chorume_camp2 === undefined ? '' : obj_anexo_to_edit?.chorume_camp2.toString().replace('.', ',')}
                                            onChange={onInputChange}
                                            error={error_chorume_camp2}
                                            helperText={error_chorume_camp2 ? "Apenas números são aceites" : ""}
                                        />
                                    </StyledTableCell>
                                    <StyledTableCell>
                                        <CustomTextField
                                            name="chorume_camp3"
                                            value={obj_anexo_to_edit?.chorume_camp3 === undefined ? '' : obj_anexo_to_edit?.chorume_camp3.toString().replace('.', ',')}
                                            onChange={onInputChange}
                                            error={error_chorume_camp3}
                                            helperText={error_chorume_camp3 ? "Apenas números são aceites" : ""}
                                        />
                                    </StyledTableCell>
                                    <StyledTableCell>
                                        <CustomTextField
                                            name="chorume_camp4"
                                            value={obj_anexo_to_edit?.chorume_camp4 === undefined ? '' : obj_anexo_to_edit?.chorume_camp4.toString().replace('.', ',')}
                                            onChange={onInputChange}
                                            error={error_chorume_camp4}
                                            helperText={error_chorume_camp4 ? "Apenas números são aceites" : ""}
                                        />
                                    </StyledTableCell>
                                    <StyledTableCell>
                                        <ButtonCadernos
                                            mostrarBotaoCancelar
                                            aoClicarCancelar={() => {
                                                if (flag_editado) {
                                                    set_open_modal_tem_a_certeza_que_quer_apagar_alteracoes(true)

                                                } else {

                                                    set_obj_anexo_to_edit(undefined)
                                                    setCreateTableChorume(false)
                                                    set_flag_editar(false)
                                                }

                                            }}
                                            mostrarBotaoGravar
                                            aoClicarGravar={() => { handle_criar_anexo() }}
                                        />
                                    </StyledTableCell>
                                </TableRow>
                            ) : (
                                <TableRow>
                                    <TableCell colSpan={7}>
                                        <Box
                                            sx={{
                                                display: "flex",
                                                justifyContent: "end",
                                                alignContent: "end",
                                            }}
                                        >
                                            {is_historico === true ? <></> :

                                                <BarraDeFerramentas
                                                    mostrarBotaoNovo
                                                    textoBotaoNovo="Adicionar linha Chorume"
                                                    aoClicarNovo={() => {
                                                        set_obj_anexo(undefined)
                                                        setCreateTableChorume(true)
                                                    }}
                                                />}
                                        </Box>
                                    </TableCell>
                                </TableRow>
                            )}

                            {filteredRowsChorume.map((tab, index) => {
                                if (tab.id_anexo_um_quatro_um === obj_anexo?.id_anexo_um_quatro_um) {
                                    return (

                                        <>
                                            <TableRow>
                                                {index === 0 && (
                                                    <StyledTableHead rowSpan={filteredRowsChorume.length}>
                                                        Chorume
                                                    </StyledTableHead>
                                                )}
                                                <StyledTableCell>
                                                    <CustomSelect
                                                        value={obj_anexo?.chorume_camp1 === undefined ? '' : obj_anexo?.chorume_camp1}
                                                        name="chorume_camp1"
                                                        onChange={onEditTableChange}
                                                        options={especie}
                                                        label="Espécie Pecuária"
                                                    />
                                                </StyledTableCell>
                                                <StyledTableCell>
                                                    <CustomTextField
                                                        name="chorume_camp2"
                                                        value={obj_anexo?.chorume_camp2 === undefined ? '' : obj_anexo?.chorume_camp2.toString().replace('.', ',')}
                                                        onChange={onEditTableChange}
                                                        error={error_chorume_camp2}
                                                        helperText={error_chorume_camp2 ? "Apenas números são aceites" : ""}
                                                    />
                                                </StyledTableCell>
                                                <StyledTableCell>
                                                    <CustomTextField
                                                        name="chorume_camp3"
                                                        value={obj_anexo?.chorume_camp3 === undefined ? '' : obj_anexo?.chorume_camp3.toString().replace('.', ',')}
                                                        onChange={onEditTableChange}
                                                        error={error_chorume_camp3}
                                                        helperText={error_chorume_camp3 ? "Apenas números são aceites" : ""}
                                                    />
                                                </StyledTableCell>
                                                <StyledTableCell>
                                                    <CustomTextField
                                                        name="chorume_camp4"
                                                        value={obj_anexo?.chorume_camp4 === undefined ? '' : obj_anexo?.chorume_camp4.toString().replace('.', ',')}
                                                        onChange={onEditTableChange}
                                                        error={error_chorume_camp4}
                                                        helperText={error_chorume_camp4 ? "Apenas números são aceites" : ""}
                                                    />
                                                </StyledTableCell>
                                                <StyledTableCell>
                                                    <ButtonCadernos
                                                        mostrarBotaoCancelar
                                                        aoClicarCancelar={() => {
                                                            if (flag_editado) {
                                                                set_open_modal_tem_a_certeza_que_quer_apagar_alteracoes(true)
                                                            } else {
                                                                set_obj_anexo(undefined)
                                                                set_obj_anexo_to_edit(undefined)
                                                                setCreateTableChorume(false)
                                                                set_flag_editar(false)
                                                                obj_anexo_lista_q2.length === 0 ? setCreateTable(true) : setCreateTable(false)
                                                            }
                                                        }}
                                                        mostrarBotaoGravar
                                                        aoClicarGravar={() => {
                                                            handle_update_anexo()
                                                        }}
                                                    />
                                                </StyledTableCell>
                                            </TableRow>
                                        </>
                                    )
                                } else {

                                    return (
                                        <TableRow key={tab.id_anexo_um_quatro_um}>
                                            {index === 0 && (
                                                <StyledTableHead rowSpan={filteredRowsChorume.length}>
                                                    Chorume
                                                </StyledTableHead>
                                            )}
                                            <StyledTableCell>{tab.chorume_camp1}</StyledTableCell>
                                            <StyledTableCell>{tab.chorume_camp2}</StyledTableCell>
                                            <StyledTableCell>{tab.chorume_camp3}</StyledTableCell>
                                            <StyledTableCell>{tab.chorume_camp4}</StyledTableCell>
                                            <StyledTableCell>
                                                {is_historico === true ? <></> :

                                                    <ButtonCadernos
                                                        mostrarBotaoEditar
                                                        aoClicarEditar={() => {
                                                            setCreateTable(false)
                                                            setCreateTableChorume(false)
                                                            setCreateTableEstrume(false)
                                                            set_obj_anexo(tab)
                                                            set_flag_editar(true)
                                                        }}
                                                        mostrarBotaoApagar
                                                        aoClicarApagar={() => {
                                                            set_obj_anexo(tab)
                                                            set_open_dialog_tem_a_certeza_que_quer_eliminar(true)
                                                        }}
                                                    />}
                                            </StyledTableCell>
                                        </TableRow>
                                    )
                                }


                            })}

                            {createTable === true && (
                                <>
                                    <TableRow>
                                        <StyledTableHead>
                                            Digerido de Unidade de Biogás
                                        </StyledTableHead>
                                        <StyledTableCell
                                            sx={{ backgroundColor: "lightgrey" }}
                                        ></StyledTableCell>
                                        <StyledTableCell>
                                            <CustomTextField
                                                name="digerido_camp2"
                                                value={obj_anexo_q2?.digerido_camp2 === undefined ? '' : obj_anexo_q2?.digerido_camp2}
                                                onChange={onEditTableChangeTable}
                                            />
                                        </StyledTableCell>
                                        <StyledTableCell>
                                            <CustomTextField
                                                name="digerido_camp3"
                                                value={obj_anexo_q2?.digerido_camp3 === undefined ? '' : obj_anexo_q2?.digerido_camp3}
                                                onChange={onEditTableChangeTable}
                                            />
                                        </StyledTableCell>
                                        <StyledTableCell>
                                            <CustomTextField
                                                name="digerido_camp4"
                                                value={obj_anexo_q2?.digerido_camp4 === undefined ? '' : obj_anexo_q2?.digerido_camp4}
                                                onChange={onEditTableChangeTable}
                                            />
                                        </StyledTableCell>
                                        <StyledTableCell rowSpan={8}>
                                            {is_historico === true ? <></> :

                                                <ButtonCadernos

                                                    mostrarBotaoGravar
                                                    aoClicarGravar={() => { handle_criar_anexo_q2() }}
                                                />}
                                        </StyledTableCell>
                                    </TableRow>
                                    <TableRow>
                                        <StyledTableHead>
                                            Sedimentos depositados nos orgãos de armazenamento de
                                            efluentes pecuários (por um período até 2 nos)
                                        </StyledTableHead>
                                        <StyledTableCell
                                            sx={{ backgroundColor: "lightgrey" }}
                                        ></StyledTableCell>
                                        <StyledTableCell>
                                            <CustomTextField
                                                name="sedimentos_camp2"
                                                value={obj_anexo_q2?.sedimentos_camp2 === undefined ? '' : obj_anexo_q2?.sedimentos_camp2}
                                                onChange={onEditTableChangeTable}
                                            />
                                        </StyledTableCell>
                                        <StyledTableCell>
                                            <CustomTextField
                                                name="sedimentos_camp3"
                                                value={obj_anexo_q2?.sedimentos_camp3 === undefined ? '' : obj_anexo_q2?.sedimentos_camp3}
                                                onChange={onEditTableChangeTable}
                                            />
                                        </StyledTableCell>
                                        <StyledTableCell>
                                            <CustomTextField
                                                name="sedimentos_camp4"
                                                value={obj_anexo_q2?.sedimentos_camp4 === undefined ? '' : obj_anexo_q2?.sedimentos_camp4}
                                                onChange={onEditTableChangeTable}
                                            />
                                        </StyledTableCell>
                                    </TableRow>
                                    <TableRow>
                                        <StyledTableHead>
                                            Mistura de um ou mais dos anteriores fertilizantes
                                        </StyledTableHead>
                                        <StyledTableCell
                                            sx={{ backgroundColor: "lightgrey" }}
                                        ></StyledTableCell>
                                        <StyledTableCell>
                                            <CustomTextField
                                                name="mistura_camp2"
                                                value={obj_anexo_q2?.mistura_camp2 === undefined ? '' : obj_anexo_q2?.mistura_camp2}
                                                onChange={onEditTableChangeTable}
                                            />
                                        </StyledTableCell>
                                        <StyledTableCell>
                                            <CustomTextField
                                                name="mistura_camp3"
                                                value={obj_anexo_q2?.mistura_camp3 === undefined ? '' : obj_anexo_q2?.mistura_camp3}
                                                onChange={onEditTableChangeTable}
                                            />
                                        </StyledTableCell>
                                        <StyledTableCell>
                                            <CustomTextField
                                                name="mistura_camp4"
                                                value={obj_anexo_q2?.mistura_camp4 === undefined ? '' : obj_anexo_q2?.mistura_camp4}
                                                onChange={onEditTableChangeTable}
                                            />
                                        </StyledTableCell>
                                    </TableRow>
                                    <TableRow>
                                        <StyledTableHead>
                                            Composto de bioresíduos de origem agrícola
                                        </StyledTableHead>
                                        <StyledTableCell
                                            sx={{ backgroundColor: "lightgrey" }}
                                        ></StyledTableCell>
                                        <StyledTableCell>
                                            <CustomTextField
                                                name="composto_camp2"
                                                value={obj_anexo_q2?.composto_camp2 === undefined ? '' : obj_anexo_q2?.composto_camp2}
                                                onChange={onEditTableChangeTable}
                                            />
                                        </StyledTableCell>
                                        <StyledTableCell>
                                            <CustomTextField
                                                name="composto_camp3"
                                                value={obj_anexo_q2?.composto_camp3 === undefined ? '' : obj_anexo_q2?.composto_camp3}
                                                onChange={onEditTableChangeTable}
                                            />
                                        </StyledTableCell>
                                        <StyledTableCell>
                                            <CustomTextField
                                                name="composto_camp4"
                                                value={obj_anexo_q2?.composto_camp4 === undefined ? '' : obj_anexo_q2?.composto_camp4}
                                                onChange={onEditTableChangeTable}
                                            />
                                        </StyledTableCell>
                                    </TableRow>
                                    <TableRow>
                                        <StyledTableHead>
                                            Composto orgânico de Unidade de tratamento de residuos
                                            sólidos urbanos (Decreto-Lei n.º 30/2022)
                                        </StyledTableHead>
                                        <StyledTableCell
                                            sx={{ backgroundColor: "lightgrey" }}
                                        ></StyledTableCell>
                                        <StyledTableCell>
                                            <CustomTextField
                                                name="opcao_um_camp2"
                                                value={obj_anexo_q2?.opcao_um_camp2 === undefined ? '' : obj_anexo_q2?.opcao_um_camp2}
                                                onChange={onEditTableChangeTable}
                                            />
                                        </StyledTableCell>
                                        <StyledTableCell>
                                            <CustomTextField
                                                name="opcao_um_camp3"
                                                value={obj_anexo_q2?.opcao_um_camp3 === undefined ? '' : obj_anexo_q2?.opcao_um_camp3}
                                                onChange={onEditTableChangeTable}
                                            />
                                        </StyledTableCell>
                                        <StyledTableCell>
                                            <CustomTextField
                                                name="opcao_um_camp4"
                                                value={obj_anexo_q2?.opcao_um_camp4 === undefined ? '' : obj_anexo_q2?.opcao_um_camp4}
                                                onChange={onEditTableChangeTable}
                                            />
                                        </StyledTableCell>
                                    </TableRow>
                                    <TableRow>
                                        <StyledTableCell>
                                            <BasicPopover
                                                text={
                                                    "Campo de preenchimento 'livre'.\n\nRegistar o fertilizante orgânico a ser utilizado quando este não se enquadra nos tipos de fertilizantes orgânicos previstos nas linhas acima."
                                                }
                                            />
                                        </StyledTableCell>
                                        <StyledTableCell
                                            sx={{ backgroundColor: "lightgrey" }}
                                        ></StyledTableCell>
                                        <StyledTableCell>
                                            <CustomTextField
                                                name="opcao_dois_camp2"
                                                value={obj_anexo_q2?.opcao_dois_camp2 === undefined ? '' : obj_anexo_q2?.opcao_dois_camp2}
                                                onChange={onEditTableChangeTable}
                                            />
                                        </StyledTableCell>
                                        <StyledTableCell>
                                            <CustomTextField
                                                name="opcao_dois_camp3"
                                                value={obj_anexo_q2?.opcao_dois_camp3 === undefined ? '' : obj_anexo_q2?.opcao_dois_camp3}
                                                onChange={onEditTableChangeTable}
                                            />
                                        </StyledTableCell>
                                        <StyledTableCell>
                                            <CustomTextField
                                                name="opcao_dois_camp4"
                                                value={obj_anexo_q2?.opcao_dois_camp4 === undefined ? '' : obj_anexo_q2?.opcao_dois_camp4}
                                                onChange={onEditTableChangeTable}
                                            />
                                        </StyledTableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell
                                            rowSpan={2}
                                            sx={{
                                                textAlign: "left",
                                                fontWeight: 600,
                                                fontFamily: "candara",
                                            }}
                                        >
                                            <Stack direction="row" justifyContent="center">
                                                Origem dos dados:
                                                <Box margin={-1} padding={0}>
                                                    <BasicPopover
                                                        text={
                                                            "Assinalar com uma X o campo correspondente à origem dos dados"
                                                        }
                                                    />
                                                </Box>
                                            </Stack>
                                        </TableCell>
                                        <TableCell colSpan={2}>
                                            <Stack
                                                direction="row"
                                                alignItems="center"
                                                justifyContent="left"
                                            >
                                                <FormControlLabel
                                                    name="origem_tabela"

                                                    label={
                                                        <Typography fontFamily="candara" fontSize={16}>
                                                            a) Tabela - Referência bibliográfica:
                                                        </Typography>
                                                    }

                                                    control={
                                                        <Checkbox
                                                            checked={!!obj_anexo_q2?.origem_tabela}
                                                            onChange={onInputChange}
                                                            name="origem_tabela"
                                                            disabled={!!flag_editar}
                                                            sx={{
                                                                color: "#aaaaaa",
                                                                "&.Mui-checked": {
                                                                    color: "#C94F1E",
                                                                },
                                                            }}
                                                        />
                                                    }
                                                />
                                            </Stack>
                                        </TableCell>
                                        <TableCell colSpan={2}>
                                            <CustomTextField
                                                name="tabela"
                                                value={obj_anexo_q2?.tabela === undefined ? '' : obj_anexo_q2?.tabela}
                                                onChange={onEditTableChangeTable}
                                            />
                                        </TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell colSpan={2}>
                                            <Stack
                                                direction="row"
                                                alignItems="center"
                                                justifyContent="left"
                                            >
                                                <FormControlLabel
                                                    name="origem_analise"
                                                    label={
                                                        <Typography fontFamily="candara" fontSize={16}>
                                                            b) Análise - Data:
                                                        </Typography>
                                                    }
                                                    aria-readonly
                                                    control={
                                                        <Checkbox
                                                            checked={!!obj_anexo_q2?.origem_analise}
                                                            onChange={onInputChange}
                                                            name="origem_analise"
                                                            disabled={!!flag_editar}
                                                            sx={{
                                                                color: "#aaaaaa",
                                                                "&.Mui-checked": {
                                                                    color: "#C94F1E",
                                                                },
                                                            }}
                                                        />
                                                    }
                                                />
                                            </Stack>
                                        </TableCell>

                                        <TableCell colSpan={2}>


                                            <TextField
                                                variant="filled"
                                                type="date"
                                                inputProps={{
                                                    style: { fontSize: 12, fontFamily: "verdana" },
                                                }}
                                                name="analise"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                value={obj_anexo_q2?.analise === undefined ? '' : obj_anexo_q2?.analise}
                                                onChange={onEditTableChangeTable}
                                            />
                                        </TableCell>
                                    </TableRow>
                                </>
                            )}

                            {obj_anexo_lista_q2.length === 0 ? <></> :
                                obj_anexo_lista_q2.map((tab, key) => {
                                    return (
                                        <>
                                            {obj_anexo_q2?.id_anexo_um_quatro_um === tab.id_anexo_um_quatro_um ? (
                                                <>
                                                    <TableRow >
                                                        <StyledTableHead>
                                                            Digerido de Unidade de Biogás
                                                        </StyledTableHead>
                                                        <StyledTableCell
                                                            sx={{ backgroundColor: "lightgrey" }}
                                                        ></StyledTableCell>
                                                        <StyledTableCell>
                                                            <CustomTextField
                                                                name="digerido_camp2"
                                                                value={obj_anexo_q2?.digerido_camp2 === undefined ? '' : obj_anexo_q2?.digerido_camp2}

                                                                onChange={onEditTableChangeTable}
                                                            />
                                                        </StyledTableCell>
                                                        <StyledTableCell>
                                                            <CustomTextField
                                                                name="digerido_camp3"
                                                                value={obj_anexo_q2?.digerido_camp3 === undefined ? '' : obj_anexo_q2?.digerido_camp3}

                                                                onChange={onEditTableChangeTable}
                                                            />
                                                        </StyledTableCell>
                                                        <StyledTableCell>
                                                            <CustomTextField
                                                                name="digerido_camp4"
                                                                value={obj_anexo_q2?.digerido_camp4 === undefined ? '' : obj_anexo_q2?.digerido_camp4}

                                                                onChange={onEditTableChangeTable}
                                                            />
                                                        </StyledTableCell>
                                                        <StyledTableCell rowSpan={8}>
                                                            <ButtonCadernos
                                                                mostrarBotaoGravar
                                                                aoClicarGravar={() => { handle_update_anexo_q2() }}
                                                                mostrarBotaoCancelar
                                                                aoClicarCancelar={() => {
                                                                    if (flag_editado) {
                                                                        set_open_modal_tem_a_certeza_que_quer_apagar_alteracoes(true)

                                                                    } else {
                                                                        setCreateTable(false)
                                                                        set_obj_anexo_q2(undefined)
                                                                        setCreateTableEstrume(false)
                                                                        setCreateTableChorume(false)
                                                                        set_flag_editar(false)
                                                                    }

                                                                }}
                                                            />
                                                        </StyledTableCell>
                                                    </TableRow>
                                                    <TableRow>
                                                        <StyledTableHead>
                                                            Sedimentos depositados nos orgãos de armazenamento
                                                            de efluentes pecuários (por um período até 2 nos)
                                                        </StyledTableHead>
                                                        <StyledTableCell
                                                            sx={{ backgroundColor: "lightgrey" }}
                                                        ></StyledTableCell>
                                                        <StyledTableCell>
                                                            <CustomTextField
                                                                name="sedimentos_camp2"
                                                                value={obj_anexo_q2?.sedimentos_camp2 === undefined ? '' : obj_anexo_q2?.sedimentos_camp2}

                                                                onChange={onEditTableChangeTable}
                                                            />
                                                        </StyledTableCell>
                                                        <StyledTableCell>
                                                            <CustomTextField
                                                                name="sedimentos_camp3"
                                                                value={obj_anexo_q2?.sedimentos_camp3 === undefined ? '' : obj_anexo_q2?.sedimentos_camp3}

                                                                onChange={onEditTableChangeTable}
                                                            />
                                                        </StyledTableCell>
                                                        <StyledTableCell>
                                                            <CustomTextField
                                                                name="sedimentos_camp4"
                                                                value={obj_anexo_q2?.sedimentos_camp4 === undefined ? '' : obj_anexo_q2?.sedimentos_camp4}

                                                                onChange={onEditTableChangeTable}
                                                            />
                                                        </StyledTableCell>
                                                    </TableRow>
                                                    <TableRow>
                                                        <StyledTableHead>
                                                            Mistura de um ou mais dos anteriores fertilizantes
                                                        </StyledTableHead>
                                                        <StyledTableCell
                                                            sx={{ backgroundColor: "lightgrey" }}
                                                        ></StyledTableCell>
                                                        <StyledTableCell>
                                                            <CustomTextField
                                                                name="mistura_camp2"
                                                                value={obj_anexo_q2?.mistura_camp2 === undefined ? '' : obj_anexo_q2?.mistura_camp2}

                                                                onChange={onEditTableChangeTable}
                                                            />
                                                        </StyledTableCell>
                                                        <StyledTableCell>
                                                            <CustomTextField
                                                                name="mistura_camp3"
                                                                value={obj_anexo_q2?.mistura_camp3 === undefined ? '' : obj_anexo_q2?.mistura_camp3}

                                                                onChange={onEditTableChangeTable}
                                                            />
                                                        </StyledTableCell>
                                                        <StyledTableCell>
                                                            <CustomTextField
                                                                name="mistura_camp4"
                                                                value={obj_anexo_q2?.mistura_camp4 === undefined ? '' : obj_anexo_q2?.mistura_camp4}

                                                                onChange={onEditTableChangeTable}
                                                            />
                                                        </StyledTableCell>
                                                    </TableRow>
                                                    <TableRow>
                                                        <StyledTableHead>
                                                            Composto de bioresíduos de origem agrícola
                                                        </StyledTableHead>
                                                        <StyledTableCell
                                                            sx={{ backgroundColor: "lightgrey" }}
                                                        ></StyledTableCell>
                                                        <StyledTableCell>
                                                            <CustomTextField
                                                                name="composto_camp2"
                                                                value={obj_anexo_q2?.composto_camp2 === undefined ? '' : obj_anexo_q2?.composto_camp2}

                                                                onChange={onEditTableChangeTable}
                                                            />
                                                        </StyledTableCell>
                                                        <StyledTableCell>
                                                            <CustomTextField
                                                                name="composto_camp3"
                                                                value={obj_anexo_q2?.composto_camp3 === undefined ? '' : obj_anexo_q2?.composto_camp3}

                                                                onChange={onEditTableChangeTable}
                                                            />
                                                        </StyledTableCell>
                                                        <StyledTableCell>
                                                            <CustomTextField
                                                                name="composto_camp4"
                                                                value={obj_anexo_q2?.composto_camp4 === undefined ? '' : obj_anexo_q2?.composto_camp4}

                                                                onChange={onEditTableChangeTable}
                                                            />
                                                        </StyledTableCell>
                                                    </TableRow>
                                                    <TableRow>
                                                        <StyledTableHead>
                                                            Composto orgânico de Unidade de tratamento de
                                                            residuos sólidos urbanos (Decreto-Lei n.º 30/2022)
                                                        </StyledTableHead>
                                                        <StyledTableCell
                                                            sx={{ backgroundColor: "lightgrey" }}
                                                        ></StyledTableCell>
                                                        <StyledTableCell>
                                                            <CustomTextField
                                                                name="opcao_um_camp2"
                                                                value={obj_anexo_q2?.opcao_um_camp2 === undefined ? '' : obj_anexo_q2?.opcao_um_camp2}

                                                                onChange={onEditTableChangeTable}
                                                            />
                                                        </StyledTableCell>
                                                        <StyledTableCell>
                                                            <CustomTextField
                                                                name="opcao_um_camp3"
                                                                value={obj_anexo_q2?.opcao_um_camp3 === undefined ? '' : obj_anexo_q2?.opcao_um_camp3}

                                                                onChange={onEditTableChangeTable}
                                                            />
                                                        </StyledTableCell>
                                                        <StyledTableCell>
                                                            <CustomTextField
                                                                name="opcao_um_camp4"
                                                                value={obj_anexo_q2?.opcao_um_camp4 === undefined ? '' : obj_anexo_q2?.opcao_um_camp4}

                                                                onChange={onEditTableChangeTable}
                                                            />
                                                        </StyledTableCell>
                                                    </TableRow>
                                                    <TableRow>
                                                        <StyledTableCell>
                                                            <BasicPopover
                                                                text={
                                                                    "Campo de preenchimento 'livre'.\n\nRegistar o fertilizante orgânico a ser utilizado quando este não se enquadra nos tipos de fertilizantes orgânicos previstos nas linhas acima."
                                                                }
                                                            />
                                                        </StyledTableCell>
                                                        <StyledTableCell
                                                            sx={{ backgroundColor: "lightgrey" }}
                                                        ></StyledTableCell>
                                                        <StyledTableCell>
                                                            <CustomTextField
                                                                name="opcao_dois_camp2"
                                                                value={obj_anexo_q2?.opcao_dois_camp2 === undefined ? '' : obj_anexo_q2?.opcao_dois_camp2}

                                                                onChange={onEditTableChangeTable}
                                                            />
                                                        </StyledTableCell>
                                                        <StyledTableCell>
                                                            <CustomTextField
                                                                name="opcao_dois_camp3"
                                                                value={obj_anexo_q2?.opcao_dois_camp3 === undefined ? '' : obj_anexo_q2?.opcao_dois_camp3}

                                                                onChange={onEditTableChangeTable}
                                                            />
                                                        </StyledTableCell>
                                                        <StyledTableCell>
                                                            <CustomTextField
                                                                name="opcao_dois_camp4"
                                                                value={obj_anexo_q2?.opcao_dois_camp4 === undefined ? '' : obj_anexo_q2?.opcao_dois_camp4}

                                                                onChange={onEditTableChangeTable}
                                                            />
                                                        </StyledTableCell>
                                                    </TableRow>
                                                    <TableRow>
                                                        <TableCell
                                                            rowSpan={2}
                                                            sx={{
                                                                textAlign: "left",
                                                                fontWeight: 600,
                                                                fontFamily: "candara",
                                                            }}
                                                        >
                                                            <Stack direction="row" justifyContent="center">
                                                                Origem dos dados:
                                                                <Box margin={-1} padding={0}>
                                                                    <BasicPopover
                                                                        text={
                                                                            "Assinalar com uma X o campo correspondente à origem dos dados"
                                                                        }
                                                                    />
                                                                </Box>
                                                            </Stack>
                                                        </TableCell>
                                                        <TableCell colSpan={2}>
                                                            <Stack
                                                                direction="row"
                                                                alignItems="center"
                                                                justifyContent="left"
                                                            >
                                                                <FormControlLabel
                                                                    name="origem_tabela"
                                                                    label={
                                                                        <Typography
                                                                            fontFamily="candara"
                                                                            fontSize={16}
                                                                        >
                                                                            a) Tabela - Referência bibliográfica:
                                                                        </Typography>
                                                                    }
                                                                    aria-readonly
                                                                    control={
                                                                        <Checkbox
                                                                            checked={!!obj_anexo_q2?.origem_tabela}
                                                                            onChange={onInputChange}
                                                                            name="origem_tabela"
                                                                            disabled={!flag_editar}
                                                                            sx={{
                                                                                color: "#aaaaaa",
                                                                                "&.Mui-checked": {
                                                                                    color: "#C94F1E",
                                                                                },
                                                                            }}
                                                                        />
                                                                    }
                                                                />
                                                            </Stack>
                                                        </TableCell>
                                                        <TableCell colSpan={2}>
                                                            <CustomTextField
                                                                name="tabela"
                                                                value={obj_anexo_q2?.tabela === undefined ? '' : obj_anexo_q2?.tabela}

                                                                onChange={onEditTableChangeTable}
                                                            />
                                                        </TableCell>
                                                    </TableRow>
                                                    <TableRow>
                                                        <TableCell colSpan={2}>
                                                            <Stack
                                                                direction="row"
                                                                alignItems="center"
                                                                justifyContent="left"
                                                            >
                                                                <FormControlLabel
                                                                    name="origem_analise"
                                                                    label={
                                                                        <Typography
                                                                            fontFamily="candara"
                                                                            fontSize={16}
                                                                        >
                                                                            b) Análise - Data:
                                                                        </Typography>
                                                                    }
                                                                    aria-readonly
                                                                    control={
                                                                        <Checkbox
                                                                            checked={!!obj_anexo_q2?.origem_analise}
                                                                            onChange={onInputChange}
                                                                            name="origem_analise"
                                                                            disabled={!flag_editar}
                                                                            sx={{
                                                                                color: "#aaaaaa",
                                                                                "&.Mui-checked": {
                                                                                    color: "#C94F1E",
                                                                                },
                                                                            }}
                                                                        />
                                                                    }
                                                                />
                                                            </Stack>
                                                        </TableCell>
                                                        <TableCell colSpan={2}>
                                                            <TextField
                                                                variant="filled"
                                                                type="date"
                                                                inputProps={{
                                                                    style: { fontSize: 12, fontFamily: "verdana" },
                                                                }}
                                                                name="analise"
                                                                InputLabelProps={{
                                                                    shrink: true,
                                                                }}
                                                                value={obj_anexo_q2?.analise === undefined ? '' : obj_anexo_q2?.analise}
                                                                onChange={onEditTableChangeTable}
                                                            />

                                                        </TableCell>
                                                    </TableRow>
                                                </>
                                            ) : (
                                                <>
                                                    <TableRow>
                                                        <StyledTableCell>
                                                            Digerido de Unidade de Biogás
                                                        </StyledTableCell>
                                                        <StyledTableCell>
                                                            {tab.digerido_camp1}
                                                        </StyledTableCell>
                                                        <StyledTableCell>
                                                            {tab.digerido_camp2}
                                                        </StyledTableCell>
                                                        <StyledTableCell>
                                                            {tab.digerido_camp3}
                                                        </StyledTableCell>
                                                        <StyledTableCell>
                                                            {tab.digerido_camp4}
                                                        </StyledTableCell>
                                                        <StyledTableCell rowSpan={8}>
                                                            {is_historico === true ? <></> :

                                                                <ButtonCadernos
                                                                    mostrarBotaoEditar
                                                                    aoClicarEditar={() => {
                                                                        set_obj_anexo_q2(tab)
                                                                        set_flag_editar(true)
                                                                    }}
                                                                    mostrarBotaoApagar
                                                                    aoClicarApagar={() => {
                                                                        set_obj_anexo_q2(tab)
                                                                        set_open_dialog_tem_a_certeza_que_quer_eliminar_q2(true)
                                                                    }}
                                                                />}
                                                        </StyledTableCell>
                                                    </TableRow>
                                                    <TableRow>
                                                        <StyledTableCell>
                                                            Sedimentos depositados nos orgãos de armazenamento
                                                            de efluentes pecuários (por um período até 2 nos)
                                                        </StyledTableCell>
                                                        <StyledTableCell>
                                                            {tab.sedimentos_camp1}
                                                        </StyledTableCell>
                                                        <StyledTableCell>
                                                            {tab.sedimentos_camp2}
                                                        </StyledTableCell>
                                                        <StyledTableCell>
                                                            {tab.sedimentos_camp3}
                                                        </StyledTableCell>
                                                        <StyledTableCell>
                                                            {tab.sedimentos_camp4}
                                                        </StyledTableCell>
                                                    </TableRow>
                                                    <TableRow>
                                                        <StyledTableCell>
                                                            Mistura de um ou mais dos anteriores fertilizantes
                                                        </StyledTableCell>
                                                        <StyledTableCell>{tab.mistura_camp1}</StyledTableCell>
                                                        <StyledTableCell>{tab.mistura_camp2}</StyledTableCell>
                                                        <StyledTableCell>{tab.mistura_camp3}</StyledTableCell>
                                                        <StyledTableCell>{tab.mistura_camp4}</StyledTableCell>
                                                    </TableRow>
                                                    <TableRow>
                                                        <StyledTableCell>
                                                            Composto de bioresíduos de origem agrícola
                                                        </StyledTableCell>
                                                        <StyledTableCell>
                                                            {tab.composto_camp1}
                                                        </StyledTableCell>
                                                        <StyledTableCell>
                                                            {tab.composto_camp2}
                                                        </StyledTableCell>
                                                        <StyledTableCell>
                                                            {tab.composto_camp3}
                                                        </StyledTableCell>
                                                        <StyledTableCell>
                                                            {tab.composto_camp4}
                                                        </StyledTableCell>
                                                    </TableRow>
                                                    <TableRow>
                                                        <StyledTableCell>
                                                            Composto orgânico de Unidade de tratamento de
                                                            residuos sólidos urbanos (Decreto-Lei n.º 30/2022)
                                                        </StyledTableCell>
                                                        <StyledTableCell>
                                                            {tab.opcao_um_camp1}
                                                        </StyledTableCell>
                                                        <StyledTableCell>
                                                            {tab.opcao_um_camp2}
                                                        </StyledTableCell>
                                                        <StyledTableCell>
                                                            {tab.opcao_um_camp3}
                                                        </StyledTableCell>
                                                        <StyledTableCell>
                                                            {tab.opcao_um_camp4}
                                                        </StyledTableCell>
                                                    </TableRow>
                                                    <TableRow>
                                                        <StyledTableCell>
                                                            <BasicPopover
                                                                text={
                                                                    "Campo de preenchimento 'livre'.\n\nRegistar o fertilizante orgânico a ser utilizado quando este não se enquadra nos tipos de fertilizantes orgânicos previstos nas linhas acima."
                                                                }
                                                            />
                                                        </StyledTableCell>
                                                        <StyledTableCell>
                                                            {tab.opcao_dois_camp1}
                                                        </StyledTableCell>
                                                        <StyledTableCell>
                                                            {tab.opcao_dois_camp2}
                                                        </StyledTableCell>
                                                        <StyledTableCell>
                                                            {tab.opcao_dois_camp3}
                                                        </StyledTableCell>
                                                        <StyledTableCell>
                                                            {tab.opcao_dois_camp4}
                                                        </StyledTableCell>
                                                    </TableRow>
                                                    <TableRow>
                                                        <TableCell
                                                            rowSpan={2}
                                                            sx={{
                                                                textAlign: "left",
                                                                fontWeight: 600,
                                                                fontFamily: "candara",
                                                            }}
                                                        >
                                                            <Stack direction="row" justifyContent="center">
                                                                Origem dos dados:
                                                                <Box margin={-1} padding={0}>
                                                                    <BasicPopover
                                                                        text={
                                                                            "Assinalar com uma X o campo correspondente à origem dos dados"
                                                                        }
                                                                    />
                                                                </Box>
                                                            </Stack>
                                                        </TableCell>
                                                        <TableCell colSpan={2}>
                                                            <Stack
                                                                direction="row"
                                                                alignItems="center"
                                                                justifyContent="left"
                                                            >
                                                                <FormControlLabel
                                                                    name="origem_tabela"
                                                                    label={
                                                                        <Typography
                                                                            fontFamily="candara"
                                                                            fontSize={16}
                                                                        >
                                                                            a) Tabela - Referência bibliográfica:
                                                                        </Typography>
                                                                    }
                                                                    aria-readonly
                                                                    control={
                                                                        <Checkbox
                                                                            checked={!!tab.origem_tabela}
                                                                            onChange={onEditTableChangeTable}
                                                                            name="origem_tabela"
                                                                            disabled={!flag_editar}
                                                                            sx={{
                                                                                color: "#aaaaaa",
                                                                                "&.Mui-checked": {
                                                                                    color: "#C94F1E",
                                                                                },
                                                                            }}
                                                                        />
                                                                    }
                                                                />
                                                            </Stack>
                                                        </TableCell>
                                                        <TableCell colSpan={2}>{tab.tabela}</TableCell>
                                                    </TableRow>
                                                    <TableRow>
                                                        <TableCell colSpan={2}>
                                                            <Stack
                                                                direction="row"
                                                                alignItems="center"
                                                                justifyContent="left"
                                                            >
                                                                <FormControlLabel
                                                                    name="origem_analise"
                                                                    label={
                                                                        <Typography
                                                                            fontFamily="candara"
                                                                            fontSize={16}
                                                                        >
                                                                            b) Análise - Data:
                                                                        </Typography>
                                                                    }
                                                                    aria-readonly
                                                                    control={
                                                                        <Checkbox
                                                                            checked={!!tab.origem_analise}
                                                                            onChange={onEditTableChangeTable}
                                                                            name="origem_analise"
                                                                            disabled={!flag_editar}
                                                                            sx={{
                                                                                color: "#aaaaaa",
                                                                                "&.Mui-checked": {
                                                                                    color: "#C94F1E",
                                                                                },
                                                                            }}
                                                                        />
                                                                    }
                                                                />
                                                            </Stack>
                                                        </TableCell>
                                                        <TableCell colSpan={2}>{tab.analise}</TableCell>
                                                    </TableRow>
                                                </>
                                            )}
                                        </>
                                    );

                                })}
                        </TableBody>
                        : <></>
                }


            </table>
            <ConfirmDialog
                open={open_dialog_tem_a_certeza_que_quer_eliminar}
                onClose={() => set_open_dialog_tem_a_certeza_que_quer_eliminar(false)}
                onConfirm={handle_delete_anexo}
                message="Deseja eliminar o registo?"
            />
            <ConfirmDialog
                open={open_dialog_tem_a_certeza_que_quer_eliminar_q2}
                onClose={() => set_open_dialog_tem_a_certeza_que_quer_eliminar_q2(false)}
                onConfirm={handle_delete_anexo_q2}
                message="Deseja eliminar o registo?"
            />
            <ConfirmDialog
                open={open_modal_tem_a_certeza_que_quer_apagar_alteracoes}
                onClose={() => set_open_modal_tem_a_certeza_que_quer_apagar_alteracoes(false)}
                onConfirm={() => handleCloseDialog()}
                message={mensagem_tem_a_certeza_de_apagar_alteracoes}
            />
        </TableContainer >

    );
};
